import Box from 'components/shared/Box'
import Price from 'components/shared/Price'
import Text from 'components/shared/Text'
import { ReactElement } from 'react'

interface OrderSectionRowProps {
    price: number
    title: ReactElement
    hasHighlightedPrice?: boolean
    hasDisclaimer?: boolean
}

const OrderSectionRow = ({
    price,
    title,
    hasHighlightedPrice,
    hasDisclaimer,
}: OrderSectionRowProps) => (
    <Box direction="row" justify="space-between" align="flex-end" isFullWidth>
        <Text variant="body" color="grayscale_900">
            {title}
            {hasDisclaimer ? '*' : undefined}:
        </Text>
        <Price
            value={price}
            size={hasHighlightedPrice ? 'heading2' : 'heading4'}
            color={hasHighlightedPrice ? undefined : 'grayscale_900'}
            currencySize={
                hasHighlightedPrice ? undefined : 'bodyExtraSmallStrong'
            }
        />
    </Box>
)

export default OrderSectionRow
